import * as React from "react";
import {Component } from "react";

import {observer} from "mobx-react";
import _ from "lodash";
import {Table} from "semantic-ui-react";
import {Bodenbedeckung} from "../../../../models/grundstueck";

export interface BodenTableProps {
    data: Bodenbedeckung[];
    highlightedItemId: string | null;
    handleHighlightClick: (e: React.MouseEvent | undefined, boden: Bodenbedeckung | null) => void;
    title?: string;
}
interface SortAction {
    type: string;
    column: string;
}
@observer
export class BodenTable extends Component<BodenTableProps, any> {
    watchHandles: any[] = [];
    constructor(props: BodenTableProps) {
        super(props);
        this.state = {
            column: "art",
            data: _.orderBy(this.props.data, ["art"], ["asc"]),
            direction: "ascending"
        };
        this.sort = this.sort.bind(this);
    }
    sort(action: SortAction): void {
        switch (action.type) {
        case "CHANGE_SORT":
            if (this.state.column === action.column) {
                this.setState({
                    ...this.state,
                    data: this.state.data.reverse(),
                    direction:
                            this.state.direction === "ascending" ? "descending" : "ascending"
                });
            } else {
                this.setState({
                    column: action.column,
                    data: _.sortBy(this.state.data, [action.column]),
                    direction: "ascending",
                });
            }
            return;
        default:
            throw new Error();
        }
    }
    handleHighlightClick(e: React.MouseEvent, boden: Bodenbedeckung): void {
        const { highlightedItemId } = this.props;
        if (boden.itemId === highlightedItemId){
            this.props.handleHighlightClick(e, null);
        } else {
            this.props.handleHighlightClick(e, boden);
        }
    }
    componentWillUnmount(): void {
        this.watchHandles.forEach((handle: any) => {
            handle.remove();
        });
        this.watchHandles.length = 0;
    }
    render(): React.ReactElement | null {
        const { data } = this.state;
        const { highlightedItemId } = this.props;
        if (data === null || data.length === 0){
            return null;
        }
        return (
            <Table basic="very" size="small" compact="very" className={"bodenbedeckung"}>
                <Table.Body>
                    {data.map((item: Bodenbedeckung) => (
                        <Table.Row key={item.id}
                            className={((item.itemId === highlightedItemId) ? "highlighted" : "")}
                            onClick={(event: React.MouseEvent) => this.handleHighlightClick(event, item)}>
                            <Table.Cell>{item.art}{item.gebaeudenummern &&
                            <span> ({item.gebaeudenummern})</span>}</Table.Cell>
                            <Table.Cell singleLine textAlign="right">
                                {new Intl.NumberFormat("de-CH").format(Math.round(item.flaeche))} m²</Table.Cell>
                        </Table.Row>
                    ))}
                </Table.Body>
            </Table>
        );
    }
}
